import Atmosphere from "@/views/editor/service/atmosphere/atmosphere";
import {INewBusiness} from "@/views/editor/service/business";

export default {'atmosphere': Atmosphere} as { [key: string]: INewBusiness }